<template>
  <component-wrapper>
    <div
      :class="{
        'section-divider-fi': true,
        'section-divider-fi--dark': isDark,
        'section-divider-fi--extra-small': getSize === 'extra-small',
        'section-divider-fi--small': getSize === 'small',
        'section-divider-fi--large': getSize === 'large',
      }"
    />
  </component-wrapper>
</template>

<script>
import ComponentWrapper from '@/components/component-wrapper/ComponentWrapper.vue';
import ssrOnlyMixin from '@/mixins/ssrOnlyMixin.vue';

export default {
  name: 'SectionDividerFi',
  components: { ComponentWrapper },
  mixins: [ssrOnlyMixin],
  props: {
    fields: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: null,
    },
    dark: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isDark() {
      if (this.fields?.dark?.value) {
        return Boolean(this.fields?.dark?.value);
      }

      return this.dark;
    },
    getSize() {
      if (this.fields?.size?.value) {
        return this.fields?.size?.value;
      }

      return this.size;
    },
  },
};
</script>

<style src="./section-divider-fi" />
